module.exports = __webpack_public_path__ + "static/media/activerefferalicon.9bf6116f.svg";